import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
`;

export const FilterChip = styled.button<{
    active?: boolean;
}>`
    padding: 12px 16px;
    background: ${({ active }) => (active ? "#F4ECFA" : "#FFFFFF")};
    border: 1px solid #d6d6d6;
    border-radius: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;

    outline: none;
    appearance: none;

    &:focus-visible {
        outline: 2px solid #6b2fa3;
        outline-offset: 2px;
    }
`;

export const ChipContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StatusDot = styled.div<{
    color: string;
}>`
    width: 12px;
    height: 8px;
    background: ${({ color }) => color};
    border-radius: 999px;
    transform: rotate(-45deg);
`;

export const Label = styled.div`
    color: #333333;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;
`;
